"use client";
import { useEffect, useContext } from "react";
import { useDataLayerContext } from "./DataLayerContextProvider";
// import { SessionContext } from "@/lib/auth/SessionContextProvider";
import { BigCommerceStoreContext } from "@/providers/BigCommerceStoreProvider";
import { ProductData } from "@/lib/5874/types";

interface Props {
	product: ProductData;
	scope: string;
}

export default function ViewItemEvent({ product, scope }: Props) {
	const { viewItem } = useDataLayerContext();
	// const session = useContext(SessionContext);
	const { currencyFormattingRules } = useContext(BigCommerceStoreContext);
	// const isLoggedIn = session?.session !== null;

	useEffect(() => {
		viewItem(product, scope, scope, currencyFormattingRules.currency);
	}, [product]);

	return null;
}
